import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { setupMockEnvironment } from './mocks/setup';
import './assets/styles/App.css';

// Configurar mock API para desarrollo
if (process.env.NODE_ENV === 'development') {
  setupMockEnvironment();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);